import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';

type DataTableProps = {
  children: React.ReactNode;
  className?: string;
};

export function DataTable({ children, className = '' }: DataTableProps) {
  return (
    <TableContainer
      className={`data-table${className ? ` ${className}` : ''}`}
      component={Paper}
      elevation={0}
    >
      <Table>{children}</Table>
    </TableContainer>
  );
}
